import { WifiSlash, CloudArrowUp } from '@phosphor-icons/react';

/**
 * SyncBanner - Displays offline status and pending sync count
 */
export default function SyncBanner({
  isOnline,
  pendingSyncCount,
  isSyncing,
  onTriggerSync,
}) {
  // Only show when offline or when there are pending changes
  if (isOnline && pendingSyncCount === 0) {
    return null;
  }

  return (
    <div 
      className="px-4 py-2 text-center text-sm font-medium"
      style={{
        backgroundColor: !isOnline ? '#FCECEB' : 'rgba(78, 143, 106, 0.15)',
        color: !isOnline ? 'var(--color-status-error)' : 'var(--color-status-success)',
      }}
    >
      <span className="inline-flex items-center gap-2">
        {!isOnline ? (
          <>
            <WifiSlash size={16} weight="bold" />
            You're offline - changes will sync when back online
            {pendingSyncCount > 0 && ` (${pendingSyncCount} pending)`}
          </>
        ) : pendingSyncCount > 0 ? (
          <>
            <CloudArrowUp size={16} weight="bold" />
            {pendingSyncCount} change{pendingSyncCount !== 1 ? 's' : ''} pending
            <button 
              onClick={onTriggerSync}
              disabled={isSyncing}
              className="ml-2 underline hover:no-underline disabled:opacity-50"
            >
              {isSyncing ? 'Syncing...' : 'Sync now'}
            </button>
          </>
        ) : null}
      </span>
    </div>
  );
}
